import { useToast } from '@chakra-ui/react';
import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../axios.ts';

export function ProtectedRoute({
  children,
  showToast = true,
  loginPage = '/',
}: { loginPage?: string; showToast?: boolean } & PropsWithChildren) {
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) return;

    if (showToast)
      toast({
        title: 'Oops!',
        description: 'Para acessar essa página você deve estar logado! Por favor, realize o login.',
        status: 'warning',
      });
    navigate(loginPage + location.search);
  }, []);

  if (isAuthenticated()) return children;

  return <></>;
}
